import getPopup, { ResGetPopup } from '@/service/layout/getPopup';
import { useViewportStore } from '@/store/useViewportStore';
import { useQuery } from '@tanstack/react-query';
import { RQLayoutKey } from './RQLayoutKey';

const usePopUpQuery = () => {
  const isMobile = useViewportStore((store) => store.isMobile);
  const sizeType = isMobile ? 'MOBILE' : 'WEB';

  return useQuery<ResGetPopup, object, ResGetPopup['result']['content']>({
    queryKey: RQLayoutKey['popup'](sizeType),
    queryFn: () => getPopup({ sizeType }),
    select: (data) => data.result.content,
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export default usePopUpQuery;
